class RedirectTo {
  private components: NodeListOf<HTMLElement>;

  constructor() {
    this.components = document.querySelectorAll(
      '[data-component="redirectTo"]'
    );

    if (this.components) {
      this._init();
    }
  }

  private _init() {
    this.components.forEach((component: HTMLElement) => {
      component.addEventListener('click', function (elt) {
        const link = this.getAttribute('data-link');
        const newWindow = this.getAttribute('data-extern');
        if (link) {
          window.location = link as any;
        }
        if (newWindow) {
          window.open(newWindow as string  , '_blank')
        }
      });
    });
  }
}

export const redirectTo = new RedirectTo();
